module.exports = __webpack_public_path__ + "static/img/title05.1442488.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title05.png
// module id = fmL3
// module chunks = 18